import { showSessionExpiredAlert } from '@contexts/Auth/sessionExpiredAlert'

interface ArriereResponse {
  response?: {
    data: any
    warnings: any
    headers: any
    status?: number
    errors: {
      message: string
    }[]
  }
}

export const arriereResponseListener = ({ response }: ArriereResponse) => {
  if (response?.status === 401) showSessionExpiredAlert()
}
